import { Component, Injector, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@uw/core/services/auth.service';
import { CampaignService } from '@uw/core/services/campaign.service';
import { filter, switchMap} from 'rxjs';
import { PostLoginNavigationComponent } from '../../components/post-login-navigation.component';
import { CustomNavigationService } from '@uw/core/custom-navigation.service';

@Component({ template: '', host: { 'data-component': 'registration-token-verification' } })
export class RegistrationTokenVerificationComponent
  extends PostLoginNavigationComponent
  implements OnInit
{

  constructor(
    protected _authService: AuthService,
    _campaignService: CampaignService,
    _router: Router,
    customNavigationService: CustomNavigationService,
    private readonly _route: ActivatedRoute,
    injector: Injector
  ) {
    super(_authService, _campaignService, customNavigationService, injector);

  }

  ngOnInit(): void {
    super.ngOnInit();

    this._route.queryParams
      .pipe(
        filter((params) => params.idToken),
        switchMap(params => this._authService.validateRegistrationToken(params.idToken))
      ).subscribe(
        authResponse => {
          this.navigateToPostLoginLoginDestinationPage(authResponse);
        },
        _err => {
          this.customNavigationService.navigate(['main/login']);
          this.showError('registration_token_verification_component.login_link_expired');
        }
      );
  }

}
